import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
import Success from "../Common/Success";
import ChatComponent from "./ChatComponent";
import chatList from "./chatList.json";
import DisconnectNetwork from "./DisconnectNetwork";

export interface ICustomChatComponent {
  displayNextSlide: () => void;
  type: number;
}

const CustomChatComponent = (props: ICustomChatComponent) => {
  const classes = useStyles();
  const [nextSlide, showNextSlide] = React.useState(0);

  const onBtnClick = () => {
    showNextSlide(nextSlide + 1);
    props.displayNextSlide();
  };

  const deleteMaliciousDialog = (
    <Box
      className={classes.positionComponent}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <DialogBox
        childProps={
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "inherit",
              width: "inherit",
            }}
          >
            <Typography
              variant="body2"
              color="white"
              sx={{ fontWeight: "600" }}
            >
              Scanning completed. Identified <br />
              areas where malicious code is
              <br /> present.
            </Typography>
            <Button
              sx={{
                borderRadius: "3rem",
                textTransform: "capitalize",
                padding: "1rem 1.5rem",
                fontSize: "1rem",
                fontWeight: "600",
                backgroundColor: "#D65C5C",
                width: "80%",
                color: "#fff",
              }}
              variant="contained"
              onClick={onBtnClick}
            >
              Delete malicious code
            </Button>
          </div>
        }
        type={4}
      />
    </Box>
  );

  return (
    <>
      <ChatComponent
        chatList={
          props.type === 0
            ? chatList[5]
            : props.type === 1
            ? chatList[6]
            : props.type === 2
            ? chatList[7]
            : chatList[8]
        }
        displayNextSlide={() => {}}
        consoleImg={
          props.type === 1 || props.type === 2 || props.type === 3
            ? false
            : true
        }
      />

      {props.type === 0 ? (
        deleteMaliciousDialog
      ) : props.type === 2 ? (
        <DisconnectNetwork displayNextSlide={onBtnClick} type={1} />
      ) : (
        <Success
          message1={"Successfully completed. "}
          message2={
            props.type === 3 ? "Backups restored" : "The system is safe"
          }
          displayNextSlide={onBtnClick}
        />
      )}
    </>
  );
};

export default CustomChatComponent;
